import { create } from 'zustand';

export const STATION_TABS = [
  'chargepoint',
  'profiles',
  'offline',
  'replay',
  'eventLog',
  'display',
  'history',
  'snapshots',
  'settings',
] as const;
export type StationTab = (typeof STATION_TABS)[number];

/** UI-only ephemeral state: form inputs, active tab, focused connector. */
export interface UIStoreState {
  authorizeInput: string;
  selectedConnectorId: number | null;
  activeTab: StationTab;
  /** NIT-011 — Event Log auto-scroll preference. Defaults ON. */
  eventLogAutoScroll: boolean;
}

export interface UIStoreActions {
  setAuthorizeInput(value: string): void;
  selectConnector(id: number | null): void;
  setActiveTab(tab: StationTab): void;
  setEventLogAutoScroll(on: boolean): void;
}

export type UIStore = UIStoreState & UIStoreActions;

export const useUIStore = create<UIStore>((set) => ({
  authorizeInput: 'TAG-1',
  selectedConnectorId: null,
  activeTab: 'chargepoint',
  eventLogAutoScroll: true,
  setAuthorizeInput(value: string): void {
    set({ authorizeInput: value });
  },
  selectConnector(id: number | null): void {
    set({ selectedConnectorId: id });
  },
  setActiveTab(tab: StationTab): void {
    set({ activeTab: tab });
  },
  setEventLogAutoScroll(on: boolean): void {
    set({ eventLogAutoScroll: on });
  },
}));
